// extracted by mini-css-extract-plugin
export var container = "fSDV2x85";
export var warningGauge = "nlN-cgQO";
export var content = "EdBBeVW1";